/* eslint-disable no-undef */
/**
 * Modelo de estado inicial para el componente IngresarAgendarCitaMedica.
 * Centraliza todas las propiedades de estado con sus valores por defecto.
 */
export const IngresarAgendarCitaMedicaModel = {
  // Autenticación
  userInfo: {},
  isAuthenticatedBoolean: false,

  // Mensajes contextuales
  viewDates: false,
  pbsMessage: parseText('Form.Content.ActualDoctorNotFound'),
  notFoundPceMessageForSpecialty: parseText('Form.Content.TreatingDoctorNotFound'),
  notFoundMessageForPersonalDoctor: parseText('Form.Content.PersonalDoctorNotFound'),
  paMessage: parseText('Form.Content.ActualDoctorNotFound'),

  // Modal general
  titleModal: '',
  messageModal: '',
  iconoModal: '',
  colorIco: '',
  noX: '',
  noAceptar: '',
  noCancelar: '',

  // Estado de citas / errores
  sinCitas: false,
  targetNotFound: false,
  iconoNotFound: 'fa fa-info-circle',
  messageNotFound:
    'Señor usuario usted no tiene médico personal asignado, si desea asignarlo por favor haga clic en el enlace ',
  error: false,
  habilitarBoton: [],

  // Selección de afiliados y especialidades
  afiliados: {},
  especialidades: {},
  userTypeId: '',
  nullResponseSpec: false,
  serviceCode: '',
  afiliateSelected: '',
  specialitySelected: '',
  userTypeIdentify: '',
  enableDropDown: false,
  enableButtonComplete: true,

  // Promoción y prevención
  isPromotionAndPrevention: false,
  infoIsPromotionActive: [],

  // Flujo de selección
  responseContent: false,
  isConditional: false,
  namePlaceholderUser: '',
  noPlacerholderUser: false,
  namePlaceholderSpec: '',
  noPlacerholderSpec: false,
  hideSedes: false,
  statusRequest: '',
  dateSelected: '',
  dataToSubmitAppoimentGroup: '',
  branchSelectedResponse: [],

  // Resultado médico
  medicalAvailable: {},
  doctorSelected: '',

  // PopUps
  popUpAdministration: {},
  popUpContent: null,
  popUpModal: false,
  popUpUbicacion: false,
  popUpApointment: false,
  showEspecialidadesPopup: false,

  // Acceso y especialidad activa
  userAppointmentAccess: null,
  specialityValueSelected: null,
  dataLayerMedicalLocations: '',

  // Servicio de red (ConsultaRedV2)
  isRedService: true,
  oneBranche: false,
  oneBrancheSelected: {},
  newBranchesRedService: [],
  cupsEvent: {},
  personalDoctor: true,
  affiliatedContactInfoRedService: {},
  baseBranches: [],
  checkedDoctorInit: false,
};
